import React from 'react'
import Switch from '@material-ui/core/Switch'
import {
  Typography,
  Grid,
  Chip,
  FormControlLabel,
  Box,
} from '@material-ui/core'
import { useDispatch } from 'react-redux'
import settingsStyles from '../settingsStyles'
import { trackEvent } from '../../../helpers/analytics'

const STATUS_MESSAGES = {
  pending: 'Loading...',
  fulfilled: 'Action Successful',
  error: 'Something went wrong, please try again.',
}

function PageLink({
  title,
  description,
  action,
  state,
  status,
  section = 'Settings',
}) {
  const classes = settingsStyles()
  const dispatch = useDispatch()

  const handleToggle = () => {
    trackEvent(dispatch, {
      eventName: 'uxp_settings_toggle',
      module: 'Settings',
      object: 'PageToggle',
      action: 'Click',
      actionContext: section,
      actionContextValue: `${title}: ${!state ? 'On' : 'Off'}`,
    })
    action(!state)
  }

  return (
    <Grid
      container
      className={classes.fullWidth}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          handleToggle()
        }
      }}
    >
      <FormControlLabel
        className={classes.fullWidthLabel}
        control={
          <Switch
            checked={state}
            onChange={handleToggle}
            color="primary"
            name="adminMode"
            tabIndex={-1}
            onClick={(e) => e.stopPropagation()}
          />
        }
        label={
          <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box>
              <Typography variant="h6">{title}</Typography>
              <Typography variant="caption" color="textSecondary">
                {description}
              </Typography>
            </Box>
            <ToggleMessageChip
              classes={classes}
              status={status}
              state={state}
            />
          </Grid>
        }
      />
    </Grid>
  )
}

export const ToggleMessageChip = ({ classes, status, state }) => {
  const getStatusMessage = () => {
    if (status) {
      return STATUS_MESSAGES[status]
    }

    return state ? 'Action Successful' : undefined
  }

  const statusMessage = getStatusMessage()
  return (
    <>
      {statusMessage && state && (
        <Box mr={2}>
          <Chip
            className={classes.pageToggleChip}
            color="primary"
            size="small"
            label={statusMessage}
          />
        </Box>
      )}
    </>
  )
}

export default PageLink
